var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHubBtnClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 22.9692L29.2661 17.7063C29.4006 17.5688 29.5871 17.4941 29.779 17.5004C30.0701 17.5027 30.3313 17.6788 30.443 17.9469C30.5555 18.2158 30.4965 18.5248 30.2935 18.7331L25.0274 23.996L30.2935 29.2588C30.4312 29.3932 30.5059 29.5795 30.4996 29.7714C30.5044 29.964 30.4296 30.1495 30.2935 30.2856C30.1574 30.4216 29.9718 30.4963 29.779 30.4915C29.5871 30.4978 29.4006 30.4231 29.2661 30.2856L24 25.0228L18.7339 30.2856C18.5278 30.4947 18.2147 30.5576 17.9433 30.4444C17.6726 30.3312 17.4972 30.0654 17.5004 29.7714C17.4941 29.5795 17.5688 29.3932 17.7065 29.2588L22.9726 23.9959L17.7065 18.7331C17.439 18.447 17.4461 18.0004 17.7238 17.7236C18.0007 17.4461 18.4476 17.439 18.7339 17.7064L24 22.9692Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubBtnClose);
export default __webpack_public_path__ + "static/media/hub_btn_close.1b3af4b0565869f7cd14ecf081047c76.svg";
export { ForwardRef as ReactComponent };